import { FC } from "react";
import { toAbsoluteUrl } from "../../../_theme/helpers";

const ArrowIcon: FC = () => {
    return (
        <img
            src={toAbsoluteUrl("media/images/arrowright-removebg-preview.png")}
            alt=""
            className="w-25px"
            loading="lazy"
        />
    );
};

export default ArrowIcon;